const dietdurationprice = {
  getlist: 'dietdurationprice/getlist-by-admin',
  add: 'dietdurationprice/add',
  update: 'dietdurationprice/update',
  remove: 'dietdurationprice/remove',
  get: 'dietdurationprice/get',
  getall: 'dietdurationprice/getall',
}
export default dietdurationprice
